'use strict';

var AppState = require('app_state');
var Bookmarks = require('models/bookmark').BookmarkList;
var BookmarkView = require('components/common/views/bookmark_view');
var ChartView = require('components/devices/views/common/chart_view');
var CommonViews = require('components/common/views');
var Consts = require('consts');
var FullScreen = require('components/common/behaviors/fullscreen');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Strings = require('utils/strings');
var utils = require('components/common/utils');

function hasPeriodInUrl() {
    var urlHash = window.location.hash;
    return urlHash.match(/analyze\/[0-9A-Za-z]+/);
}

var AnalyzeView = Marionette.LayoutView.extend({
    chartDisplayed: false,
    controller: undefined,
    showEvents: false,
    template: require('components/devices/templates/common/analyze'),
    model: {},
    events: {
        'changed.bs.select @ui.timeRange': function () {
            var period = $(this.ui.timeRange).val();
            this.setPeriod(period);
        },

        'mouseenter [data-toggle="tooltip"]': utils.showTooltip,
        'click .js-configure-chart': function (e) {
            if (this.controller.analyze.showChartConfigurationDialog(this, this.controller)) {
                this.charts.reload();
            }
        },

        'click .dygraph-legend': function (e) {
            if (this.controller.analyze.showChartConfigurationDialog(this, this.controller)) {
                this.charts.reload();
            }
        },
        'click .dygraph-legend-extern': function (e) {
            if (this.controller.analyze.showChartConfigurationDialog(this, this.controller)) {
                this.charts.reload();
            }
        },
        'click .js-chart-copy-link': function (e) {
            this.copyLink(e);
        },
        'click .js-chart-show-events': function (e) {
            this.showEvents = !this.showEvents;
            if (this.showEvents) this.ui.btnShowButtons.addClass('btn-selected');
            else this.ui.btnShowButtons.removeClass('btn-selected');
            this.redrawChartKeepZoom();
            this.state.showEvents = this.showEvents;
            this.controller.analyze.updateUrl(this.state.period);
            if (this.controller.analyze.configChanged) {
                this.controller.analyze.configChanged();
            }
        },
    },

    regions: {
        messageContainer: '.js-chart-message-container',
        chartContainer: '.chart-container',
        chartWrapper: '.chart-wrapper',
        configuration: '#configuration-region',
    },
    ui: {
        chartToolbarButtons: '.chart-toolbar button',
        btnShowButtons: '.js-chart-show-events',
        timeRange: '#js-predefined-timerange',
    },

    behaviors: {
        fullscreen: { behaviorClass: FullScreen },
    },

    rangeFormat: 'DD.MM.YYYY HH:mm',
    selectedPeriod: undefined,
    charts: undefined,

    getDatePicker: function () {
        if (this.datePicker === undefined) {
            this.datePicker = $('.input-daterange-timepicker');
        }
        return this.datePicker;
    },

    copyLink: function (e) {
        e.preventDefault();
        Strings.copyToClipboard(window.location.href.replace(/\/analyze\/?([a-z0-9]*)\/?\?/, '/analyze-predefined?'));
        Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Link wurde in die Zwischenablage kopiert.'));
    },

    setPermission: function (permissions) {
        this.canShowEvents = permissions.get(Consts.Permissions.EventLog) !== undefined;
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.chartData = this.model.get('chartData');
        this.charts = new ChartView({
            data: this.chartData,
            currentDeviceCategory: this.model.get('category'),
        });
        this.state = this.chartData.state;
        this.showEvents = AppState.getChartShowEventsFromURL();
        this.state.showEvents = this.showEvents;
        var getURLPartsAndSplitter = function () {
            var url = window.location.href;
            var splitString = '/analyze';
            if (url.includes('analyze-predefined')) {
                splitString = 'analyze-predefined';
            }
            var splitURL = url.split(splitString);
            return {
                splitString: splitString,
                prefix: splitURL[0],
                suffix: splitURL[1],
            };
        };

        this.bmView = new BookmarkView({
            userCanEditPublic:
                AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices) ||
                AppState.hasCompanyPermission(Consts.PermissionsCompany.RemoveDevices) ||
                AppState.hasCompanyPermission(Consts.PermissionsCompany.ViewDevices),
            applyConfig: function (configuration) {
                // Tell Backbone about the changes in the url so it will not prevent the reload
                Backbone.history.fragment = window.location.href;
                var urlParts = getURLPartsAndSplitter();
                window.location.href = urlParts.prefix + urlParts.splitString + configuration.url;
            },
            getCurrentPageConfiguration: function () {
                var urlParts = getURLPartsAndSplitter();
                // Remove the name attribute if no label is set to allow custom data point names to be displayed.
                var splitAt = 'chart_content=';
                var parts = urlParts.suffix.split(splitAt);
                if (parts.length > 1) {
                    var urlObject = JSON.parse(decodeURIComponent(parts[1]));
                    _.each(urlObject.lines, function (line) {
                        if (line.label == '') {
                            delete line.name;
                        }
                    });
                    return { url: parts[0] + splitAt + encodeURIComponent(JSON.stringify(urlObject)) };
                }
                return { url: urlParts.suffix };
            },
            configurationsAreEqual: function (config1, config2) {
                var simplifyContent = function (url) {
                    var parameter = new URLSearchParams(decodeURIComponent(url).split('?')[1]);
                    var timeIndex = url.split('?')[0].split('/').length - 1;
                    return {
                        content: JSON.parse(parameter.get('chart_content')),
                        timePeriode: url.split('?')[0].split('/')[timeIndex],
                        showEvents: parameter.get('show_events') == 'true',
                    };
                };

                var invalidOrEqual = function (prop_1, prop_2) {
                    var invalid = function (prop) {
                        return prop === undefined || prop === '' || prop === 'NaN' || prop === null;
                    };
                    return (invalid(prop_1) && invalid(prop_2)) || prop_1 == prop_2;
                };

                var c1 = simplifyContent(config1.url);
                var c2 = simplifyContent(config2.url);
                var matched = c1.timePeriode == c2.timePeriode;
                matched = matched && c1.showEvents == c2.showEvents;
                if ((c1.content && !c2.content) || (c2.content && !c1.content)) {
                    return false;
                }
                if (c1.content && c2.content) {
                    matched = matched && c1.content.advanced_mode == c2.content.advanced_mode;
                    if ((c1.content.lines && !c2.content.lines) || (c2.content.lines && !c1.content.lines)) {
                        return false;
                    }
                    if (c1.content.lines && c2.content.lines && matched) {
                        matched = c1.content.lines.length == c2.content.lines.length;
                        if (!matched) {
                            return matched;
                        }
                        var i = 0;
                        while (matched && i < c2.content.lines.length) {
                            matched = matched && invalidOrEqual(c1.content.lines[i].color, c2.content.lines[i].color);
                            matched = matched && invalidOrEqual(c1.content.lines[i].name, c2.content.lines[i].name);
                            matched = matched && invalidOrEqual(c1.content.lines[i].id, c2.content.lines[i].id);
                            matched = matched && invalidOrEqual(c1.content.lines[i].op, c2.content.lines[i].op);
                            matched = matched && invalidOrEqual(c1.content.lines[i].device, c2.content.lines[i].device);
                            matched =
                                matched && invalidOrEqual(c1.content.lines[i].device2, c2.content.lines[i].device2);
                            matched = matched && invalidOrEqual(c1.content.lines[i].field2, c2.content.lines[i].field2);
                            matched =
                                matched &&
                                invalidOrEqual(
                                    c1.content.lines[i].display.aggregation,
                                    c2.content.lines[i].display.aggregation
                                );
                            matched =
                                matched &&
                                invalidOrEqual(
                                    c1.content.lines[i].display.difference,
                                    c2.content.lines[i].display.difference
                                );
                            matched =
                                matched &&
                                invalidOrEqual(
                                    c1.content.lines[i].display.timewindow,
                                    c2.content.lines[i].display.timewindow
                                );
                            matched =
                                matched &&
                                invalidOrEqual(c1.content.lines[i].display.type, c2.content.lines[i].display.type);
                            matched =
                                matched &&
                                invalidOrEqual(c1.content.lines[i].display.valid, c2.content.lines[i].display.valid);
                            i++;
                        }
                    }
                }
                return matched;
            },
            resetBookmark: function () {
                this.applyConfig({ url: '' });
            },
            bookmarks: this.options.bookmarks,
            page: 'charts',
        });
        this.controller.analyze.configChanged = $.proxy(this.bmView.configChanged, this.bmView);
        this.controller.analyze.bookmarkChangedOnLoad = $.proxy(this.bmView.bookmarkChangedOnLoad, this.bmView);
    },

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this, arguments);
        data.canShowEvents = this.canShowEvents;
        data.showEvents = this.showEvents;
        return data;
    },

    redrawChartKeepZoom: function () {
        this.charts.showEvents = this.showEvents;
        this.charts.redraw();
    },

    redrawChart: function (selectedSeries, isReload) {
        var picker = this.getDatePicker().data('daterangepicker');
        var fromDate = picker.startDate.toDate();
        var tillDate = picker.endDate.toDate();
        var self = this;

        if (selectedSeries !== undefined) {
            this.charts.selectedSeries = selectedSeries;
        }

        if (this.controller.analyze.series.selected(this.controller.analyze.bookmarkChangedOnLoad).length == 0) return;

        // request
        this.hideMessage();
        this.charts.displayData(
            fromDate,
            tillDate,
            this.controller.analyze.series.selected(this.controller.analyze.bookmarkChangedOnLoad),
            isReload,
            isReload && !this.selectedPeriod.moved,
            function () {
                self.chartDisplayed = true;
            },
            function () {
                self.showMessage(
                    i18n.TR('Keine Daten verfügbar'),
                    i18n.TR('Zu diesem Zeitraum und Gerät/Einstellung stehen keine Daten zur Verfügung.')
                );
            },
            this.showEvents
        );
    },

    showMessage: function (title, text) {
        var messageView = new CommonViews.Message({ title: title, text: text, messageID: 'analyze' });
        this.messageContainer.show(messageView);

        $(this.regions.messageContainer).show();
    },

    hideMessage: function () {
        $(this.regions.messageContainer).hide();
        $(this.regions.chartWrapper).show();
    },

    // set the displayed time period
    setPeriod: function (period, isReload, keepPeriod, fromURL) {
        var wasFree = this.selectedPeriod !== undefined && this.selectedPeriod.free;

        if (typeof period === 'string') {
            period = this.controller.analyze.timePeriods.getByName(period);
        }

        if (period === undefined) {
            period = this.controller.analyze.timePeriods.getByName(
                this.selectedPeriod.originalName || this.selectedPeriod.name
            );
        }

        period.fromAutoReload = isReload;

        var self = this;
        this.selectedPeriod = period;

        if (fromURL || period.updateRange || (!keepPeriod && (period.moved || !period.free))) {
            this.getDatePicker().data('daterangepicker').setStartDate(period.from);
            this.getDatePicker().data('daterangepicker').setEndDate(period.till);
        }

        if (period.free && !fromURL) {
            this.updateFreePeriod(period);
        }
        this.state.period = period;
        this.controller.analyze.updateUrl(period);

        if (wasFree || !period.free || period.updateRange || !this.chartDisplayed)
            this.redrawChart(undefined, isReload);

        this.ui.timeRange.val(period.name);
        this.ui.timeRange.selectpicker('refresh');
        this.trigger('charts:period:set');
        if (this.getChildView('configuration')) {
            this.getChildView('configuration').configChanged();
        }
    },

    updateFreePeriod: function (period) {
        if (period.free) {
            var picker = this.getDatePicker().data('daterangepicker');
            var fromDate = picker.startDate.toDate();
            var tillDate = picker.endDate.toDate();
            period.from = fromDate;
            period.till = tillDate;
            this.trigger('charts:period:set');
        }
    },

    removeDisabledTooltips: function () {
        // get all disabled buttons
        var disabledButtons = $(this.regions.chartWrapper).find('button[disabled="disabled"]');
        _.each(disabledButtons, function (btn) {
            var tooltip = $(btn).attr('aria-describedby');
            if (tooltip && tooltip.indexOf('tooltip') === 0) {
                $(btn).trigger('mouseleave');
            }
        });
    },

    onRender: function () {
        Misc.initSelectPicker();
    },

    onShow: function () {
        var self = this;
        Misc.initSelectPicker();
        this.chartContainer.show(this.charts);

        // Date range picker
        this.getDatePicker().daterangepicker(Misc.setDatePickerOptions(), function (start, end, label) {
            self.setPeriod('free', false, true);
            self.updateFreePeriod(self.selectedPeriod);
            self.redrawChart();
        });

        var periodInfo = AppState.getChartPeriodFromURL();
        if (periodInfo && periodInfo.from && !hasPeriodInUrl()) {
            this.setPeriod(this.controller.analyze.timePeriods.getFree(periodInfo), false, false, true);
        } else {
            // set default from and till
            var defaultPeriod = this.controller.analyze.timePeriods.getDefault();
            if (defaultPeriod && defaultPeriod.name) {
                this.setPeriod(defaultPeriod);
            }
        }

        $('button').tooltip({
            trigger: 'manual',
            html: true,
            container: 'body',
        });

        // Are there any configured fields to chart? When not, complain...
        if (this.controller.analyze.series.selected(this.controller.analyze.bookmarkChangedOnLoad).length == 0) {
            this.showMessage(i18n.TR('Keine Daten verfügbar'), i18n.TR('Das Gerät liefert keine Daten.'));
            // hide toolbar -> can not be fixed here
            $(this.regions.chartWrapper).hide();
        }

        // show bookmarks
        if (!this.options.bookmarks.fetchSuccessfull) {
            Notification.show('error', i18n.TR('Fehler'), i18n.TR('Lesezeichen konnten nicht geladen werden.'));
        }

        this.showChildView('configuration', this.bmView);
    },
});

module.exports = AnalyzeView;
